import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clarification-inner',
  templateUrl: './clarification-inner.component.html',
  styleUrls: ['./clarification-inner.component.scss']
})
export class ClarificationInnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
